import { Log } from '@scayle/storefront-nuxt'
import type { Experiment, ActiveExperiments } from './experiment'
import useStringCookie from './useStringCookie'

export default defineNuxtPlugin((nuxtApp) => {
  const experiments = useState<Experiment[] | null>('experiments')

  if (import.meta.server && !experiments.value) {
    const allExperiments = (nuxtApp.ssrContext?.event.node.req as any)
      .experiments as Experiment[]
    experiments.value = allExperiments?.filter((i) => i.valid) || []
  }

  return {
    provide: {
      experiments: {
        list: experiments.value || [],
        isActive: (experimentName: string, variantName?: string) => {
          const experiment = experiments.value?.find(
            (i: Experiment) => i.name === experimentName,
          )
          if (!variantName) {
            return !!experiment
          }
          return experiment?.selectedVariant === variantName || false
        },
        toggleToolbar: () => {
          const toolbarCookie = useStringCookie('experiments-toolbar', {
            req: nuxtApp.ssrContext?.event.node.req,
            res: nuxtApp.ssrContext?.event.node.res,
            ttlDays: 30,
            path: '/',
            log: Log.default,
          })
          if (toolbarCookie.get()) {
            toolbarCookie.delete()
          } else {
            toolbarCookie.set('true')
          }
          location.reload()
        },
      } as ActiveExperiments,
    },
  }
})
